import { Flashbar } from '@amzn/awsui-components-console';
import { linkify } from './linkify';

interface AsyncErrorBarProps {
  error: string | null | undefined;
  header?: string;
}

/**
 * Tier 1: Sticky error bar for async/DDB errors (e.g., buildSubmitError).
 * Purely prop-driven — no internal state. Not dismissible.
 * Only renders when error is non-empty.
 *
 * Any http(s) URL in the error (e.g. the Fusion User Guide build-permissions
 * link the service appends to a missing-permission build error) is rendered as
 * a clickable external link via linkify().
 */
export const AsyncErrorBar = ({
  error,
  header = 'Build Submit Error',
}: AsyncErrorBarProps) => {
  if (!error) return null;

  return (
    <Flashbar
      items={[
        {
          header,
          type: 'error',
          content: linkify(error),
          dismissible: false,
          id: 'async-error',
        },
      ]}
    />
  );
};
